var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1061,
    height: 1050,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2571,
    y: 1724,
    width: 1061,
    height: 1050
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2571 -1724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2573.5 2249C2573.5 1960.43 2809.89 1726.5 3101.5 1726.5 3393.11 1726.5 3629.5 1960.43 3629.5 2249 3629.5 2537.57 3393.11 2771.5 3101.5 2771.5 2809.89 2771.5 2573.5 2537.57 2573.5 2249Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#222222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2788.5 2249C2788.5 2075.31 2928.86 1934.5 3102 1934.5 3275.14 1934.5 3415.5 2075.31 3415.5 2249 3415.5 2422.69 3275.14 2563.5 3102 2563.5 2928.86 2563.5 2788.5 2422.69 2788.5 2249Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#838282",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurbine);
export default __webpack_public_path__ + "static/media/Turbine.65ae85e346bff9ed7f9f082f32d8d0f5.svg";
export { ForwardRef as ReactComponent };